import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    CREATE_PRODUCT_MASTER_FAILURE,
    CREATE_PRODUCT_MASTER_FORM,
    CREATE_PRODUCT_MASTER_REQUEST,
    CREATE_PRODUCT_MASTER_SUCCESS,
    DELETE_PRODUCT_MASTER_FAILURE,
    DELETE_PRODUCT_MASTER_REQUEST,
    DELETE_PRODUCT_MASTER_SUCCESS,
    FETCH_PRODUCT_MASTER_FAILURE,
    FETCH_PRODUCT_MASTER_REQUEST,
    FETCH_PRODUCT_MASTER_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_FAILURE,
    FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_REQUEST,
    FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS,
    FETCH_SINGLE_PRODUCT_MASTER_FAILURE,
    FETCH_SINGLE_PRODUCT_MASTER_REQUEST,
    FETCH_SINGLE_PRODUCT_MASTER_SUCCESS,
    RESET_PRODUCT_MASTER_INFO,
    UPDATE_PRODUCT_MASTER_FAILURE,
    UPDATE_PRODUCT_MASTER_REQUEST,
    UPDATE_PRODUCT_MASTER_SUCCESS
} from './product.actionsType';

// FETCH PARTY MASTER DATA
export let fetchProductMasterData = () => {
    let config = {
        method: 'get',
        url: ConstantApi.productGET,
        responseTypeRequest: FETCH_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PRODUCT_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE PARTY MASTER FORM
export let createProductForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_PRODUCT_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE PARTY MASTER
export let createProductMaster = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldFKItemType: parseInt(formData.fldFKItemType),
        fldFKProductCategory: parseInt(formData.fldFKProductCategory)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.productPOST}`,
        responseTypeRequest: CREATE_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: CREATE_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: CREATE_PRODUCT_MASTER_FAILURE,
        resetFormData: RESET_PRODUCT_MASTER_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProductMasterData()
    };
    return axiosCall(config);
};

// GET SINGLE PARTY MASTER
export let getSingleProductMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.productGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_PRODUCT_MASTER_FAILURE,
        singlApiArray: [
            fetchPropertyDataForProductMaster(9), // Product Item
            fetchPropertyDataForProductMaster(10) // Product Category
        ]
    };
    return axiosCall(config);
};

//UPDATE PARTY MASTER
export let updateProductMaster = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldFKItemType: parseInt(formData.fldFKItemType),
        fldFKProductCategory: parseInt(formData.fldFKProductCategory)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.productPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_PRODUCT_MASTER_FAILURE,
        resetFormData: RESET_PRODUCT_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchProductMasterData()
    };
    return axiosCall(config);
};

// DELETE PARTY MASTER
export let deleteProductMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.productDELETE}/${id}`,
        responseTypeRequest: DELETE_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: DELETE_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: DELETE_PRODUCT_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchProductMasterData()
    };
    return axiosCall(config);
};

export let fetchPropertyDataForProductMaster = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};
